import React from 'react'
import { useParams } from 'react-router'
import { Checkbox, Divider, Group, Stack, Text, Title } from '@mantine/core'
import { usePricingVersionCache, useUpdatePricingVersion, useUpdateVersionRules, useVersionRulesCache } from '../../../../../hooks/global-job-matching'
import { JobsSelection } from '../../../GlobalJobMatchingVersioning/types/rules'
import { JobsFilters } from './JobsFilters'
import { PropagateMatches } from './PropagateMatches'
import { RadioCard } from '../../../../common'

export const Jobs = () => {
  const params = useParams<{id: string}>()
  const rules = useVersionRulesCache(params.id)
  const version = usePricingVersionCache(params.id)
  const { mutate: updateRules } = useUpdateVersionRules(params.id)
  const { mutate: updateVersion } = useUpdatePricingVersion(params.id)

  const shadow = (option: JobsSelection) => option === rules?.jobsSelection ? 'xl' : 'xs'

  return (
    <Stack p='xl' h='calc(100vh - 300px)' style={{ overflow: 'scroll' }}>
      <Title order={2} style={{ fontWeight: 600 }}>What jobs do you want to include in this rule?</Title>
      <Text  size='lg'>Select company jobs to include in this rule.</Text>
      <Group miw={600} maw={1400} wrap='nowrap' mb='md'>
        <RadioCard
          label='All Jobs'
          h={66}
          w={300}
          checked={rules?.jobsSelection === 'all'}
          onClick={() => updateRules({ jobsSelection: JobsSelection.ALL_JOBS })}
          shadow={shadow(JobsSelection.ALL_JOBS)}
        />
        <RadioCard
          label='Select Jobs'
          h={66}
          w={300}
          checked={rules?.jobsSelection === 'select'}
          onClick={() => {
            updateRules({ jobsSelection: JobsSelection.SELECT_JOBS })
            updateVersion({ shouldPropagate: false })
          }}
          shadow={shadow(JobsSelection.SELECT_JOBS)}
        />
      </Group>
      { version.matchStrategy === 'file' &&
      <Checkbox
        checked={version.shouldPropagate}
        label='Propagate matches'
        size='lg'
        ml='md'
        disabled={rules?.jobsSelection === 'select'}
        onChange={e => updateVersion({ shouldPropagate: e.currentTarget.checked })}
      />
      }
      <Divider my='lg' />
      <JobsFilters />
      <PropagateMatches />
    </Stack>
  )
}
